import { render, staticRenderFns } from "./IntroducitonContent5.vue?vue&type=template&id=2790781e&scoped=true"
import script from "./IntroducitonContent5.vue?vue&type=script&lang=js"
export * from "./IntroducitonContent5.vue?vue&type=script&lang=js"
import style0 from "./IntroducitonContent5.vue?vue&type=style&index=0&id=2790781e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2790781e",
  null
  
)

export default component.exports